import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slider", "value", "hidden"]

  connect() {
    this.updateAllSliders()
  }

  updateAllSliders() {
    this.sliderTargets.forEach(slider => {
      this.updateSlider(slider)
    })
  }

  updateSlider(slider) {
    const value = slider.value
    const competencyId = slider.dataset.competencyId
    const valueDisplay = this.element.querySelector(`[data-competency-id="${competencyId}"] .competency-value`)
    const hiddenField = this.element.querySelector(`input[name*="[${competencyId}][weight]"]`)
    
    if (valueDisplay) {
      valueDisplay.textContent = value
    }
    
    if (hiddenField) {
      hiddenField.value = value
    }
  }

  sliderChanged(event) {
    this.updateSlider(event.target)
  }

  toggleCompetency(event) {
    const checkbox = event.target
    const competencyId = checkbox.dataset.competencyId
    const isChecked = checkbox.checked
    
    const competencyCard = checkbox.closest('.bg-gray-50')
    if (!competencyCard) return

    const sliderContainer = competencyCard.querySelector('.competency-slider')
    if (!sliderContainer) return

    const slider = sliderContainer.querySelector('input[type="range"]')
    const hiddenField = competencyCard.querySelector(`input[name*="[${competencyId}][weight]"]`)
    
    if (isChecked) {
      // Show slider and set to 5
      sliderContainer.classList.remove('hidden')
      slider.value = 5
      if (hiddenField) {
        hiddenField.value = 5
      }
      this.updateSlider(slider)
    } else {
      // Hide slider and set to 0
      sliderContainer.classList.add('hidden')
      slider.value = 0
      if (hiddenField) {
        hiddenField.value = 0
      }
      this.updateSlider(slider)
    }
  }
}